import { ElementState, Preview } from "@creatomate/preview";

import { Organization, Story, Template } from "chq";

import getDefaultSource from "./getDefaultSource";
import { imageSlideshowTemplate, imageSlideshowWithCaptionsTemplate, intuitiveNameandTitleOverlay, IrcMontageTemplate, IrcMontageTemplateNoIntro, microsoftAmplifyTemplate, Santander4_5wRedLogoOutro, Santander4_5wWhiteLogoOutro, SantanderLandscapeWhiteWordmarkLogoOutroAnimation, SantanderLandscapewRedLogoOutro, SantanderLandscapewRedWordmarkLogoOutro, SantanderLandscapewWhiteWordmarkLogoOutro, setStorySlideshowTemplate } from "../../sidebar/tabs/template/implementors/implementors";

export interface ImplementorMontageTemplateParams {
  template: Template;
  preview: Preview;
  selectedStories: Story[];
  onStoryUpdate: (story: Story) => void;
  organization?: Organization;
  prompt?: string;
}

const templateFunctions: {
  [key: string]: (params: ImplementorMontageTemplateParams) => Promise<void>;
} = {
  "Image Slideshow": imageSlideshowTemplate,
  "Image Slideshow with captions": imageSlideshowWithCaptionsTemplate,
  "Story Slideshow": setStorySlideshowTemplate,
  "Microsoft Amplify Template w/ White Outro": microsoftAmplifyTemplate,
  "Santander Landscape w/ White Wordmark Logo Outro and animation": SantanderLandscapeWhiteWordmarkLogoOutroAnimation,
  "Santander Landscape w/ Red Wordmark Logo Outro": SantanderLandscapewRedWordmarkLogoOutro,
  "Santander Landscape w/ White Wordmark Logo Outro": SantanderLandscapewWhiteWordmarkLogoOutro,
  "Santander Landscape w/ Red Logo Outro": SantanderLandscapewRedLogoOutro,
  "Santander 4:5 w/ White Logo Outro": Santander4_5wWhiteLogoOutro,
  "Santander 4:5 w/ Red Logo Outro": Santander4_5wRedLogoOutro,
  "Intuitive name and title overlay": intuitiveNameandTitleOverlay,
  "IRC Montage": IrcMontageTemplate,
  "IRC Montage (no intro)": IrcMontageTemplateNoIntro
};

const setMontageCustomTemplate = async (
  template: Template,
  preview: Preview,
  organization: Organization,
  prompt: string | undefined,
  selectedStories: Story[],
  onStoryUpdate: (story: Story) => void,
  mediaElements: ElementState[] = []
): Promise<void> => {
  const templateFunction = templateFunctions[template.name];
  if (templateFunction) {
    await templateFunction({
      template,
      preview,
      selectedStories,
      onStoryUpdate,
      organization,
      prompt
    });
  } else {
    await preview.setSource(await getDefaultSource({ mediaElements, organization, preview }));
  }
};

export default setMontageCustomTemplate;
